import xianlu from './map/xianlu.png'
import youju from './map/youju.png'
import chongdianzhuang from './map/chongdianzhuang.png'
import chetou from './map/chetou.png'
import guaxiang from './map/guaxiang.png'
import zaihuo from './map/zaihuo.png'
import baoche from './map/baoche.png'
import baocheyitiche from './map/baocheyitiche.png'
import zaihuobaoche from './map/zaihuobaoche.png'

export {
  zaihuobaoche,
  baoche,
  baocheyitiche,
  xianlu,
  youju,
  chongdianzhuang,
  chetou,
  guaxiang,
  zaihuo,
}

export default {
  zaihuobaoche,
  baoche,
  baocheyitiche,
  xianlu,
  youju,
  chongdianzhuang,
  chetou,
  guaxiang,
  zaihuo,
}